import { Editor, Element, Transforms } from 'slate';
import { createParagraphNode } from '@app/components/rich-text-editor-toolbars/node-types/text';
import { createTableNode } from '@app/components/rich-text-editor-toolbars/node-types/table';

/**
 * Inserts a new table into the editor at the current selection and sets the cursor to the first cell.
 *
 * The function performs the following operations:
 * 1. Creates and inserts a new 2x2 table at the current cursor position
 * 2. Finds the first table cell in the newly inserted table
 * 3. Sets the cursor position to the first cell of the table
 *
 * @param {Editor} editor - The Slate editor instance
 * @returns {void}
 *
 * @example
 * // Usage in a button click handler
 * const handleAddTable = () => {
 *   addTable(editor);
 * };
 */
export const addTable = (editor: Editor) => {
  Transforms.insertNodes(
    editor,
    [
      createTableNode(),
      createParagraphNode(),
    ],
    {
      select: true,
    },
  );

  const [cell] = Editor.nodes(editor, {
    match: (n) => (n as Element).type === 'table-cell',
    mode: 'lowest',
    at: Editor.before(editor, editor.selection),
  });

  if (!cell) {
    return;
  }

  const newPath = [
    ...cell[1],
  ];

  newPath[newPath.length - 1] = 0;
  newPath[newPath.length - 2] = 0;
  newPath.push(0);

  Transforms.select(editor, newPath);
};
